// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","logo":"Header_logo__9YFPc","media":"Header_media__czWoQ"};